<template>
  <div class="actions" :class="customClass">
    <v-menu
      left
      attach
      v-if="computedItems.length > 1 || isMenuList"
      :close-on-content-click="true"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <DotsVerticalIcon @mousedown.stop />
        </v-btn>
      </template>

      <v-list class="px-0 py-0">
        <template v-for="(action, i) in computedItems">
          <v-list-item
            data-action="action"
            @click="emitAction(action)"
            :key="i">
            <div class="d-flex align-center">
              <div v-if="useSvgIcons" class="pr-2">
                <Img
                  v-if="action.svgIcon"
                  :src="getImgWithExt(['icons/results-tab', action.svgIcon, 'svg'])"
                  class="action-icon"
                />
              </div>

              <div v-else-if="action.icon" class="pr-2">
                <v-icon :color="action.color">{{action.icon}}</v-icon>
              </div>

              <div v-if="action.name">{{action.name}}</div>
            </div>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>

    <div v-else class="d-flex justify-center">
      <template v-if="useSvgIcons">
        <Img
          :src="getImgWithExt(['icons/results-tab', computedItems[0].svgIcon, 'svg'])"
          class="action-icon"
          @click.native="emitAction(computedItems[0])"
        />
      </template>
      <template v-else>
        <v-icon
          @click.native="emitAction(computedItems[0])"
          :color="computedItems[0].color"
        >
          {{ computedItems[0].icon }}
        </v-icon>
      </template>
    </div>
  </div>
</template>

<script>
import Img from '@/components/elements/Img'
import Image from '@/mixins/Image'

import DotsVerticalIcon from '@/assets/icons/components/dots-vertical.svg'

export default {
  name: 'action',
  mixins: [Image],
  components: { Img, DotsVerticalIcon },
  props: {
    items: {
      type: Array
    },
    item: {
      type: Object
    },
    additionalParams: {
      type: Object
    },
    isMenuList: {
      type: Boolean,
      default: false
    },
    useSvgIcons: {
      type: Boolean,
      default: false
    },
    customClass: {
      type: String,
      default: ''
    }
  },
  methods: {
    action (item) {
      item.actions = !item.actions
    },
    emitAction (params) {
      this.$emit('action', { params, id: this.item.id, data: this.item, additionalParams: this.additionalParams })
    }
  },
  computed: {
    computedItems () {
      if (!this.additionalParams) {
        return this.items
      } else {
        return this.items.filter(item => item.higherRights)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .actions {
    ::v-deep .v-menu {
      &__content {
        border-radius: 8px;
      }
    }

    &.actions--results {
      ::v-deep .v-menu {
        .v-menu__content {
          min-width: 159px !important;
          left: auto !important;
          right: 21px;
          background-color: #ffffff;
          box-shadow:
            0px 20px 24px 0px #14253F0F,
            0px 0px 1px 0px #0C1A4B1A;
          padding: 12px;

          .v-list {
            display: flex;
            flex-direction: column;
            row-gap: 6px;
          }

          .v-list-item {
            display: flex;
            align-items: center;
            column-gap: 4px;
            color: #425466;
            font-size: 14px;
            font-weight: 500;
            line-height: 14px;
            border-radius: 4px;
            padding: 10px 11px 8px;
            min-height: 16px;

            &:hover {
              background-color: #EDF2F7;
            }
          }
        }
      }
    }
  }
</style>
